<template>
  <div>
    <v-dialog persistent v-model="show" max-width="760">
      <v-card>
        <v-card-title class="headline">Editar envío</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" v-if="mostrarCajasConGuias">
                EDICION DE GUIAS ENVÍO #REF
                {{ idEnvioEditar }}
                <div  v-for="(envio, index) in arregloDeDatosEnvios" :key="index">
                  <v-text-field
                    @input="cambiaDeGuiaAInsertar(index)"
                    @keyup.down="tabularGuiasEntreEllas(index, 'abajo')"
                    @keyup.up="tabularGuiasEntreEllas(index, 'arriba')"
                    :ref="'guiaNumber' + index"
                    autofocus
                    :label="'Guía #' + (index + 1)"
                    @focus="$event.target.select()"
                    outlined
                    dense
                    v-model="arregloDeDatosEnvios[index].guia"
                  ></v-text-field>
                </div>
                <!-- <v-text-field
                  :error-messages="descripcionErrors"
                  @input="$v.objetoDescuento.Descripcion.$touch()"
                  @blur="$v.objetoDescuento.Descripcion.$touch()"
                  v-model="objetoDescuento.Descripcion"
                  autofocus
                  dense
                  label="Descripción"
                ></v-text-field> -->
              </v-col>
            </v-row>
            {{ informacionPasadaParaCopiar }}
            <v-row v-if="informacionPasadaParaCopiar.length > 1">
              <v-col>
                <v-textarea
                  style="height:0;width:0;opacity:0;"
                  ref="textArea2DatosACopiar"
                  id="textArea2DatosACopiar"
                  v-model="datosQueSeVanACopiar"
                  solo
                  name="input-7-4"
                  label="Solo textarea"
                ></v-textarea>
                <v-btn block color="blue" @click="copiarPaso2()" dark>copiar</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" :disabled="queInterfazMeLlama!='noAgregarEnvios'" text @click="$emit('cerrar-modal-edicion-envios')"
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" @click="actualizarGuias()" text>Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    arregloDeDatosEnvios: [],
    datosQueSeVanACopiar: "",
    mostrarCajasConGuias:true,
  }),
  props: {
    idEnvioEditar: Number,
    show: Boolean,
    informacionPasadaParaCopiar: {
      type: String,
      default: ""
    },
    queInterfazMeLlama:{
      type:String,
      default:'noAgregarEnvios'
    }
  },
  async mounted() {
    let datosCopiadosSeparados = "";
    if (this.informacionPasadaParaCopiar.length > 1) {
      this.datosQueSeVanACopiar = this.informacionPasadaParaCopiar;
      //separamos los renglones de la cadena que nos enviaron
      datosCopiadosSeparados = this.informacionPasadaParaCopiar.split("\n");
      // reemplazamos la que tiene el id por la del envio que estamos editando, que seria ya el correcto
      datosCopiadosSeparados[24] = this.idEnvioEditar;
      console.log(datosCopiadosSeparados);
      //reconstruimos objeto a copiar
      this.datosQueSeVanACopiar =
        datosCopiadosSeparados[0] +
        "\n" +
        datosCopiadosSeparados[1] +
        "\n" +
        datosCopiadosSeparados[2] +
        "\n" +
        datosCopiadosSeparados[3] +
        "\n" +
        datosCopiadosSeparados[4] +
        "\n" +
        datosCopiadosSeparados[5] +
        "\n" +
        datosCopiadosSeparados[6] +
        "\n" +
        datosCopiadosSeparados[7] +
        "\n" +
        datosCopiadosSeparados[8] +
        "\n" +
        datosCopiadosSeparados[9] +
        "\n" +
        datosCopiadosSeparados[10] +
        "\n" +
        datosCopiadosSeparados[11] +
        "\n" +
        datosCopiadosSeparados[12] +
        "\n" +
        datosCopiadosSeparados[13] +
        "\n" +
        datosCopiadosSeparados[14] +
        "\n" +
        datosCopiadosSeparados[15] +
        "\n" +
        datosCopiadosSeparados[16] +
        "\n" +
        datosCopiadosSeparados[17] +
        "\n" +
        datosCopiadosSeparados[18] +
        "\n" +
        datosCopiadosSeparados[19] +
        "\n" +
        datosCopiadosSeparados[20] +
        "\n" +
        datosCopiadosSeparados[21] +
        "\n" +
        datosCopiadosSeparados[22] +
        "\n" +
        datosCopiadosSeparados[23] +
        "\n" +
        datosCopiadosSeparados[24] +
        "\n" +
        datosCopiadosSeparados[25] +
        "\n" +
        datosCopiadosSeparados[26];
      await this.copiarPaso2();
    }
    await this.getGuiasDeEnvio(this.idEnvioEditar);
    let copiaDeGuiasEnviadas = JSON.parse(JSON.stringify(this.guiasEnvio));
    console.log(this.arregloDeDatosEnvios);
    // let arrayGuias = [];
  
        for (let i = 0; i < copiaDeGuiasEnviadas.length; i++) {
          this.arregloDeDatosEnvios.push();
          this.arregloDeDatosEnvios[i]=new Object();
          this.arregloDeDatosEnvios[i].indice=i+1;
          this.arregloDeDatosEnvios[i].guia=copiaDeGuiasEnviadas[i];
        }
  console.log(this.arregloDeDatosEnvios);
  },
  computed: {
    ...mapState("enviosEdicion", {
      guiasEnvio: state => state.guiasEnvio
    })
  },
  methods: {
    ...mapActions("enviosEdicion", ["getGuiasDeEnvio", "updateGuiasDeEnvio"]),
    ...mapActions("enviosInfoEnvio", ["chargeGuiasAgregadasDespues"]),
    copiarPaso2: _.debounce(async function(index) {
      let testingCodeToCopy = document.querySelector("#textArea2DatosACopiar");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();
      var successful = document.execCommand("copy");
    }, 100),
    cambiaDeGuiaAInsertar: _.debounce(async function(index) {
      //ocultamos las cajas de texto de las guias
      this.mostrarCajasConGuias=false;
      if (this.arregloDeDatosEnvios[index].guia.length >= 12) {
        if (this.arregloDeDatosEnvios[index].guia.length == 34) {
          this.arregloDeDatosEnvios[index].guia = this.arregloDeDatosEnvios[index].guia.substring(
            this.arregloDeDatosEnvios[index].guia.length - 12,
            this.arregloDeDatosEnvios[index].guia.length
          );
        } else if (this.arregloDeDatosEnvios[index].guia.length == 16) {
          this.arregloDeDatosEnvios[index].guia = this.arregloDeDatosEnvios[index].guia.substring(
            0,
            this.arregloDeDatosEnvios[index].guia.length - 4
          );
        }
        await this.tabularconDelay(index,'abajo');
      }
      else{
        this.mostrarCajasConGuias=true;
      }
      //mostramos otra vez la lista de guias para que se vea el cambio
      
    }, 200),
    tabularconDelay: _.debounce(async function(index,direccion) {
      console.log(index,direccion);
      this.tabularGuiasEntreEllas(index, direccion);
      this.mostrarCajasConGuias=true;
    }, 5),
    tabularGuiasEntreEllas: _.debounce(async function(index, direccion) {
      try {
        //si el indice es igual a la longitud pues no se puede ir hacia abajo
        // si el indice es cero ya no puede subir en el arreglo porque esta en el topo
        if (direccion == "abajo" && this.arregloDeDatosEnvios.length != index + 1) {
          this.$refs[`guiaNumber${index + 1}`][0].focus();
        } else if (direccion == "arriba" && index != 0) {
          this.$refs[`guiaNumber${index - 1}`][0].focus();
        }
      } catch (error) {
        console.log("errorsito");
      }
    }, 100),
    async actualizarGuias() {
      let arrayGuias = [];
      
        for (let i = 0; i < this.arregloDeDatosEnvios.length; i++) {
          arrayGuias.push(this.arregloDeDatosEnvios[i].guia)
        }
      
      await this.chargeGuiasAgregadasDespues(arrayGuias);
      const res = await this.updateGuiasDeEnvio({
        Id: this.idEnvioEditar,
        Guias: arrayGuias
      });
      if (res[0]) {
        this.$emit("cerrar-modal-edicion-envios");
        this.$emit("mostrar-mensaje-edicion-envios");
      } else {
        console.log("error");
        this.$emit("mostrarMensajeError", res[1]);
      }
    }
  }
};
</script>

<style lang="css"></style>
